import React, { createContext, useCallback, useContext, useMemo, useState } from "react";
import { DICTS, LOCALES } from "@/lib/i18n";

const KEY = "voix:lang";
const I18nContext = createContext(null);
export const useI18n = () => useContext(I18nContext);

const detectDefault = () => {
  try {
    const saved = localStorage.getItem(KEY);
    if (saved && LOCALES[saved]) return saved;
    const nav = (navigator.language || "en").slice(0, 2).toLowerCase();
    return LOCALES[nav] ? nav : "en";
  } catch (err) {
    console.warn("[voix] i18n detect failed:", err);
    return "en";
  }
};

export function I18nProvider({ children }) {
  const [lang, setLangState] = useState(detectDefault);

  const setLang = useCallback((next) => {
    if (!LOCALES[next]) return;
    setLangState(next);
    try {
      localStorage.setItem(KEY, next);
    } catch (err) {
      console.warn("[voix] i18n persist failed:", err);
    }
  }, []);

  const t = useCallback((key, vars) => {
    const dict = DICTS[lang] || DICTS.en;
    let s = dict[key] || DICTS.en[key] || key;
    if (vars) Object.entries(vars).forEach(([k, v]) => { s = s.replace(`{${k}}`, v); });
    return s;
  }, [lang]);

  const value = useMemo(() => ({ lang, setLang, t }), [lang, setLang, t]);
  return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>;
}
